<template>
  <transition name="modal">
    <div
      v-if="visible"
      class="fixed"
      @click.self="cancelPopup"
    >
      <div class="popup-card">
        <div class="popup-badge">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        <h2 class="title">{{ title }}</h2>
        <p class="message">{{ message }}</p>
        
        <div class="button-group">
          <button @click="cancelPopup" class="secondary_button">{{ cancelButton }}</button>
          <button @click="acceptPopup" class="main_button">{{ acceptButton }}</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue';

const props = defineProps({
  title: String,
  message: String,
  acceptButton: String,
  cancelButton: String,
});

const emit = defineEmits(['acceptCallback', 'cancelCallback']);

const visible = ref(false);

watch(() => props.title, (newVal) => {
  visible.value = !!newVal;
});

const acceptPopup = () => {
  visible.value = false;
  emit('acceptCallback');
};

const cancelPopup = () => {
  visible.value = false;
  emit('cancelCallback');
};
</script>

<style scoped>
.modal-enter-active, .modal-leave-active {
  transition: opacity 0.25s ease;
}

.modal-enter-from, .modal-leave-to {
  opacity: 0;
}

.modal-enter-active .popup-card {
  transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.25s ease;
}

.modal-enter-from .popup-card {
  transform: scale(0.94) translateY(8px);
  opacity: 0;
}

.popup-card {
  background-color: #FFFFFF;
  padding: 2.25rem 2rem;
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-xl);
  border: 1px solid var(--border-color);
  width: 90%;
  max-width: 440px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.popup-badge {
  width: 48px;
  height: 48px;
  border-radius: var(--radius-full);
  background-color: rgba(47, 72, 88, 0.08);
  color: var(--gray);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}

.title {
  margin-bottom: 0.5rem;
  color: var(--text-color-dark);
  font-size: 1.35rem;
  font-family: "GatterSans";
  font-weight: 700;
}

.message {
  color: var(--text-color-light);
  margin-bottom: 1.75rem;
  line-height: 1.55;
  font-size: 0.95rem;
  white-space: pre-line;
}

.button-group {
  display: flex;
  gap: 0.75rem;
  width: 100%;
}

.button-group button {
  flex: 1;
  height: 42px;
}

@media (max-width: 768px) {
  .popup-card {
    width: 92%;
    padding: 1.5rem;
  }

  .button-group {
    flex-direction: column-reverse;
  }
}
</style>
  